export default "__VITE_ASSET__DoMqmd3D__"